import { produce } from 'immer';
import type { ToBeTyped } from 'app/globalTypes';
import type { TypedReduxActionOutcomes } from 'app/store/storeTypes';
import { INVALIDATE_DATASET } from 'app/store/datasetData/types.js';
import { SET_DATASET_COLUMN_FILTER, SET_EXPLORE_COLUMN_FILTER } from './types';

export type ColumnFilterSlice = {
    byLocation: {
        dataset: Record<string, string[]>;
        explore: Record<string, Record<string, string[]>>;
    };
};

export const INITIAL_STATE: ColumnFilterSlice = {
    byLocation: {
        dataset: {},
        explore: {}
    }
};

export const columnFilterReducer = produce((draft, action: TypedReduxActionOutcomes) => {
    switch (action.type) {
        case SET_DATASET_COLUMN_FILTER: {
            const { entityId, columnList } = action.payload;

            draft.byLocation.dataset[entityId] = columnList;

            break;
        }
        case SET_EXPLORE_COLUMN_FILTER: {
            const { entityId, queryUuid, columnList } = action.payload;

            draft.byLocation.explore[entityId] ||= {};
            draft.byLocation.explore[entityId]![queryUuid] = columnList;

            break;
        }

        // @ts-expect-error [TODO] type dataset data store slice
        case INVALIDATE_DATASET: {
            const { payload } = action as ToBeTyped;
            delete draft.byLocation.dataset[payload.entityId];
            delete draft.byLocation.explore[payload.entityId];
            break;
        }
        default:
            break;
    }
}, INITIAL_STATE);
